// @ts-nocheck
import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import { hotjar } from 'react-hotjar';
import { useLocation } from "react-router-dom";

import config from "../config";

if (config.HOTJAR_ID) {
  hotjar.initialize({ id: Number(config.HOTJAR_ID), sv: 6 });
}

export const GoogleAnalytics = () => {
  const location = useLocation();

  // --- Google Analytics ---
  React.useEffect(() => {
    // @ts-ignore
    if (!window.GA_INITIALIZED && config.GA_ID) {
      ReactGA.initialize(config.GA_ID);
      // @ts-ignore
      window.GA_INITIALIZED = true;
    }
  }, []);

  // --- Meta Pixel ---
  useEffect(() => {
    if (!config.META_PIXEL_ID) return;

    if (!window.fbq) {
      (function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js"
      );

      // Initialize Facebook Pixel
      window.fbq("init", config.META_PIXEL_ID);
    }

    (window as any).fbq("track", "PageView");
  }, []);

  useEffect(() => {
    if (window.GA_INITIALIZED) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname,
        title: "Visito App",
      });
    }
    if (config.META_PIXEL_ID && (window as any).fbq) {
      (window as any).fbq("track", "PageView");
    }
  }, [location.pathname]);

  return <></>;
};

export default GoogleAnalytics;
